/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
import { useOnClickOutside } from "../../../../../../../CommonMethods/OutsideClick";
import { ShimmerTitle } from 'react-shimmer-effects'

const DropDownComponent = ({
    placeHolder,
    id,
    divClassName,
    options,
    handleOnchangeInput,
    value,
    dropDownName,
    index,
    buttonDisabled,
    buttonClassName,
    tooltip,
    test_id,
    listWidth,
    isDisplay,
    loading,
    nameKey = "name", // The default key for option name
    formatOptionName = null // New prop to format the option name
}) => {
    const [isOpen, setisOpen] = useState(false);
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);

    useOnClickOutside(ref, () => {
        setisOpen(false);
    });

    const calculateDropdownPosition = () => {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - buttonRect.bottom - 40;
        const dropdownHeight = dropdownRef.current.clientHeight;

        if (spaceBelow < dropdownHeight) {
            dropdownRef.current.style.top = `-${dropdownHeight}px`;
        } else {
            dropdownRef.current.style.top = '100%';
        }
    };

    useEffect(() => {
        window.addEventListener('resize', calculateDropdownPosition);
        calculateDropdownPosition(); // Initial position calculation
        return () => {
            window.removeEventListener('resize', calculateDropdownPosition);
        };
    }, [isOpen]);

    const getOptionName = (option) => {
        // Check if exam_name or exam exists in the option object
        if (option?.exam_name) {
            return option.exam_name;
        } else if (option?.exam) {
            return option.exam;
        } else if (formatOptionName) {
            return formatOptionName(option);
        } else {
            return option?.[nameKey];
        }
    };

    return (
        <div className={divClassName !=undefined ? divClassName : 'w-full relative'} data-te-dropdown-ref id={id} ref={ref}>
            <button
                ref={buttonRef}
                disabled={buttonDisabled !== undefined && buttonDisabled}
                title={value}
                onClick={() => setisOpen(!isOpen)}
                className={`slct-inpt-fld transition duration-150 ease-in-out `}
                type="button"
                id={dropDownName}
                data-testid={test_id}
                data-te-dropdown-toggle-ref
                aria-expanded="false"
            >
                <p
                    className={`text-f7 ${
                        (value === "" || value === undefined || value === true)
                            ? "text-[#818E98]"
                            : "text-[#031624]"
                    } font-normal `}
                >
                    {(value === "" || value === undefined || value === true)
                        ? placeHolder
                        : value}
                </p>
                <img
                    src="/images/dropdown-icon.png"
                    alt="icon"
                    className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${
                        isOpen ? "transform rotate-180" : ""
                    }`}
                />
            </button>
            <ul
                ref={dropdownRef}
                className={`slct_drp_dwn min-w-full ${listWidth}  ${
                    isOpen ? "" : "hidden"
                } [&[data-te-dropdown-show]]:block`}
                aria-labelledby="dropdownMenu_acdemic_year"
                data-te-dropdown-menu-ref
                title={value}
            >
                <li className="max-h-[220px] overflow-auto scroll-bar">
                    <ul>
                        {
                            loading ? (
                                <p className="text-2xl font-bold text-[#031624] mb-4 mt-4 px-2"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                            ) : (
                                options?.length > 0 ?
                                    options?.map((option, i) => (
                                        <li
                                            key={i}
                                            id={dropDownName + i}
                                            onClick={(e) => {
                                                handleOnchangeInput(dropDownName, option, index),
                                                setisOpen(false);
                                            }}
                                        >
                                            <a
                                                title={getOptionName(option)} // Using the formatted option name here
                                                className="slct_drp_dwn_optn"
                                            >
                                                {getOptionName(option)} {/* Display the formatted option name */}
                                            </a>
                                        </li>
                                    )) : (
                                        <li
                                            key=""
                                            id="select-option"
                                            onClick={(e) => {
                                                setisOpen(false);
                                            }}
                                        >
                                            <a className="slct_drp_dwn_optn">
                                                - No options available -
                                            </a>
                                        </li>))}
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default DropDownComponent;
